class DashboardService {
  constructor(config, httpDim) {
    this.httpDim = httpDim;
    this.config = config;
  }

  getCounts() {
    const url = this.config.apiRoot + '/dashboard';
    var config = this.config;

    return this.httpDim.get(url, config);
  }

}

DashboardService.$inject = ['config', 'httpDim'];

export
default DashboardService;


// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.service.js